import {NavLink} from 'react-router-dom';

import {PANEL_ROUTES} from '../app/routes.js';

/**
 * A prévia aprovada usava botões com `aria-selected`. Aqui são links de rota,
 * que é o que eles de fato são, e o estado ativo é `aria-current="page"`. O CSS
 * canônico reproduz a mesma geometria para o `<a>`.
 */
export const PrimaryNav = () => (
  <nav className="dm-nav" aria-label="Seções do painel">
    {PANEL_ROUTES.map(({path, navLabel, Icon}) => (
      <NavLink key={path} to={path}>
        <Icon aria-hidden="true" />
        <span>{navLabel}</span>
      </NavLink>
    ))}
  </nav>
);
